



















import Vue from "vue";
import { DateTime } from "luxon";
import { Availability } from "../types";
import { formattedDate } from "../utils";
import SpecificAvailability from "./SpecificAvailability.vue";

export default Vue.extend({
  props: {
    date: {
      type: Object as () => DateTime,
      required: true
    },
    availabilities: {
      type: Array as () => Availability[],
      required: true
    }
  },

  computed: {
    moments(): DateTime[] {
      return this.availabilities
        .map((a: Availability) =>
          DateTime.fromISO(a.starts_at, { zone: "UTC" })
        )
        .sort();
    }
  },

  methods: {
    formattedDate
  },

  components: {
    SpecificAvailability
  }
});
